module.exports = __webpack_public_path__ + "media/anim2.21360f9d.webm";